import { useTranslation } from 'react-i18next'
import { cn } from '@dashboard/ui'
import { SidebarColumn } from '@/ui'
import { Website } from '@/api/dashboard'
import { HubSettingsSidebarMenu } from '@/layouts/hub-settings/widgets/HubSettingsSidebarMenu'
import { ComponentProps } from 'react'

type HubSettingsSidebarProps = ComponentProps<typeof Header> & ComponentProps<typeof HubSettingsSidebarMenu>

export const HubSettingsSidebar = ({ website, pages }: HubSettingsSidebarProps) => (
  <SidebarColumn header={<Header website={website} />}>
    <HubSettingsSidebarMenu pages={pages} />
  </SidebarColumn>
)

interface HeaderProps {
  website: Website
}

function Header({ website }: HeaderProps) {
  const { t } = useTranslation()

  return (
    <div className="overflow-hidden rounded-lg border border-border-primary bg-fg-primary p-1.5 shadow-xs">
      <div
        className={cn(
          'flex items-center gap-2 overflow-hidden',
          '[mask-image:linear-gradient(to_right,black_90%,transparent_100%)]',
        )}
      >
        <div>
          <div
            className="flex size-[38px] shrink-0 items-center justify-center rounded bg-cover bg-center bg-no-repeat"
            style={{
              backgroundImage: `url(${website.game.logo_url})`,
            }}
          />
        </div>

        <div className="flex flex-col">
          <span className="truncate text-caption-sm text-text-tertiary">{t('hub-settings')}</span>
          <span className="truncate text-caption-md font-semibold text-text-primary">{website.game.name}</span>
        </div>
      </div>
    </div>
  )
}
